import apiClient from './apiClient';
import { CraysEvent } from '../../types';

const eventsApi = {
  listEvents: (cursor?: string) =>
    apiClient.get('/events', { params: { cursor } }).then((r) => r.data),

  getEvent: (id: string) =>
    apiClient.get(`/events/${id}`).then((r) => r.data),

  rsvpEvent: (id: string) =>
    apiClient.post(`/events/${id}/rsvp`).then((r) => r.data),

  cancelRsvp: (id: string) =>
    apiClient.delete(`/events/${id}/rsvp`).then((r) => r.data),
};

export type { CraysEvent };
export default eventsApi;
